<template>
  <div style="clear: both;">
    
    <v-textarea
      name="processingComments"
      :label="$t('Prompt_AssistFacilitatorComments')"
      :model-value="modelValue"
      auto-grow
      variant="underlined"
      rows="1"
      :readonly="readonly"
      v-on:update:model-value="updateValue"
      hide-details="auto"
      :placeholder="$t('No_Comments')"
    ></v-textarea>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
export default {
  name: 'ProcessingCommentsField',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    roles: {
      type: Array,
      default: null
    },
    mocFormStatus: {
      type: String
    },
    previousFormStatus: {
      type: Object
    }
  },
  computed: {
    readonly: function() {
      switch (this.mocFormStatus) {
        case FormStatus.properties[FormStatus.NEW].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          return true
        case FormStatus.properties[FormStatus.DRAFT].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          return true
        case FormStatus.properties[FormStatus.SENTBACKFORCORRECTIONS].value:
          if (
            this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
            this.roles.includes(Roles.properties[Roles.COINITIATOR].value)
          ) {
            return false
          }
          return true
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
          if (
            (this.previousFormStatus.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value ||
              this.previousFormStatus.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value) &&
            (this.roles.includes(Roles.properties[Roles.INITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.COINITIATOR].value) ||
              this.roles.includes(Roles.properties[Roles.OWNER].value))
          ) {
            return false
          }
          return true
        default:
          return true
      }
    }
  },
  methods: {
    updateValue: function(value) {
      // this.$emit('input', value)
      this.$emit('update:modelValue', value)
    }
  }
}
</script>

<style scoped></style>
